export default [
    '$scope',
    '$location',
    'SPModal',
    'SPClientRoute',
    'SPClientData',
    'spHiddenAlbum',
    function AlbumAuthController(
        $scope,
        $location,
        SPModal,
        SPClientRoute,
        SPClientData,
        spHiddenAlbum
    ) {
        $scope.handleChangePassword = function handleChangePassword(password) {
            $scope.albumAuth.password = password;
        };

        $scope.albumAuth = {
            password: ''
        };

        $scope.album = $scope.response.album;

        $scope.closeAndGoHome = function closeAndGoHome() {
            SPModal.close();

            if (spHiddenAlbum.isInFlow()) {
                // Declining the hidden album itself leaves the flow for the landing page, since
                // the gallery home would load its content before the gallery's password applies
                if (String(spHiddenAlbum.id) === String($scope.album.id)) {
                    spHiddenAlbum.leaveFlowToLandingPage();

                    return;
                }

                // The gallery home doesn't list the hidden album, so go back to it
                $location.path('album/' + spHiddenAlbum.id);

                return;
            }

            $location.path('home');
        };

        if ($scope.requiresPassword === undefined) {
            $scope.requiresPassword = true;
        }

        $scope.authenticate = function authenticate() {
            authenticateAlbum();
        };

        $scope.decline = function decline() {
            if ($scope.isHidden) {
                $location.url('/');
            } else {
                var parentUri = SPClientRoute.getParentUri($scope.album.parentAlbumId);

                $location.url(parentUri);
            }
        };

        function authenticateAlbum() {
            function errorMessage(response) {
                return response.errors.password.passwordNotMatch;
            }

            if ($scope.requiresPassword) {
                SPClientData.authenticateAlbum(
                    $scope.album,
                    $scope.albumAuth.password,
                    function onSuccess() {
                        if ($scope.onAuthentication) {
                            $scope.onAuthentication($scope.albumAuth);
                            SPModal.close();
                        } else {
                            closeAndReload();
                        }
                    },
                    function withResponse(response) {
                        $scope.errors = response.errors;
                        $scope.errorMessage = errorMessage(response);
                        $scope.isInvalid = true;
                    }
                );
            } else {
                closeAndReload();
            }

            function closeAndReload() {
                SPModal.close();
                SPClientRoute.reload();
            }
        }
    }
];
